/**
 * Frame-accurate step. Routes through zapd-engine bridge when active
 * (= frame-step in pause via worker's frameStep handler) for our
 * WebCodecs+OffscreenCanvas pipeline. Falls back to native
 * `seekToNextFrame()` (Chrome) or `1/fps`-currentTime nudge for the
 * legacy <video>-element path.
 *
 * Always pauses the video before stepping.
 */

export async function frameStep(video, fps, frameStepCount, direction, engineBridge) {
  if (!video.paused) video.pause();
  const f = fps || 24;
  const steps = direction * (frameStepCount || 1);

  // 2026-05-08: zapd-engine path — worker has direct access to decoded
  // frame queue + decoder pool, so frame-step is much more efficient
  // (queue-pop for forward in buffer; keyframe-restart-+-decode for
  // backward or out-of-buffer).
  if (engineBridge && typeof engineBridge.frameStep === 'function') {
    try { engineBridge.frameStep(steps); return; } catch { /* fall through */ }
  }

  // Legacy native-<video> path: seekToNextFrame is Chrome-only + only
  // forward; for everything else nudge currentTime by 1/fps.
  const stepSec = steps / f;
  try {
    if (steps === 1 && typeof video.seekToNextFrame === 'function') {
      await video.seekToNextFrame();
    } else {
      video.currentTime = Math.max(0,
        Math.min(video.duration || 1e9, video.currentTime + stepSec));
    }
  } catch { /* noop */ }
}
